module.exports = __webpack_public_path__ + "img/mococa.b2373448.png";